import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { useAuthStore } from "@/stores/authStore";
import publicRoutes from "./publicRoutes";
import privateRoutes, { visibleOrNotAuthorized } from "./privateRoutes";
import fallbackRoute from "./fallbackRoutes";
import i18n from "@/i18n";

const routes: Array<RouteRecordRaw> = [
  ...publicRoutes,
  ...privateRoutes,
  ...fallbackRoute,
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach((to, from, next) => {
//   const authStore = useAuthStore();
//   const isLoggedIn = authStore.isLoggedIn;

//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (isLoggedIn) {
//       next(); // Allow navigation
//     } else {
//       next("/"); 
//     }
//   } else {//     
//     next();
//   }
// });

// router.beforeEach((to, from, next) => {
//   const authStore = useAuthStore();
//   const isLoggedIn = authStore.isLoggedIn;
//   const title = to.meta.title as string || 'Default Title'; 
//   document.title = title; 

//   if (isLoggedIn) {
//     console.log(localStorage.getItem('access_token'));
//     next(); 
//   } else {
//     if (to.matched.some(record => record.meta.requiresAuth)) {
//       next('/'); 
//     } else {    
//       next(); 
//     }
//   }
// });

router.afterEach((to) => {
  const baseTitle = "energielenker connect -";
  const titleKey = to.meta.titleKey as string;

  if (titleKey) {
    document.title = `${baseTitle} ${i18n.global.t(titleKey)}`;
  } else {
    document.title = baseTitle;
  }
});

// router.afterEach((to) => {
//   const baseTitle = "energielenker connect -";
//   const titleKey = to.meta.titleKey as string;

//   document.title = titleKey
//     ? `${baseTitle} ${i18n.global.t(titleKey)}`
//     : baseTitle;
// });

router.beforeEach(async (to, from, next) => {
  
  const authStore = useAuthStore();

  const isAuthenticated = await authStore.validateToken();

  // fix for admin load to not return to home page
  if (isAuthenticated) {
    await authStore.fetchUserIfNeeded();
  }
  // Org-Admin, Tenant Owner and Tenant Admin can reach /admin; Technician and
  // End User cannot. Finer-grained per-section scoping (own tenant only,
  // tenant-members only, etc.) is handled inside the individual admin views.
  const hasAdminAccess = authStore.hasAdminAccess;



  const title = to.meta.title as string || 'energielenker connect';
  document.title = title;

  const isPublicRoute = to.matched.every(
    (record) => record.meta.requiresAuth === false
  );

  if (isAuthenticated && isPublicRoute && !to.meta.reachableSignedIn) {
    return next("/home");
  }

  if (!isAuthenticated && to.matched.some((r) => r.meta.requiresAuth)) {
    return next("/sign-in");
  }
 
  if (to.matched.some((r) => r.meta.requiresAdmin) && !hasAdminAccess) {
    return next("/not-authorized"); 
  }

  if (to.matched.some((r) => r.meta.requiresDeviceAdmin) && !authStore.canAccessAdminDevices) {
    return next("/not-authorized");
  }

  if (to.matched.some((r) => r.meta.requiresUserAdmin) && !authStore.canAccessAdminUsers) {
    return next("/not-authorized");
  }

  if (to.matched.some((r) => r.meta.requiresSystemStatus) && !authStore.canSeeSystemStatus) {
    return next("/not-authorized");
  }

  next();
});

router.beforeResolve(visibleOrNotAuthorized);

export default router;
